import Resource from 'Resources/Resource';

class ProjectBoardResource extends Resource {
	constructor() {
		super('projectBoards');
	}
}

export default new ProjectBoardResource();
